module.exports = __webpack_public_path__ + "assets/2c10b4971812b0797e28ac0e3fd7b0d5.png";